<template>
    <div>
        <div v-for="volume in volumes" :key="volume.branchID">
            <color-feature :volume="volume" :meshMaterial="getMeshMaterialFromVolume(volume)"></color-feature>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import ColorFeature from './color-feature';

    export default {
        name: "SelectionFeature",

        computed: {
            ...mapState("volume_store", {
                volumes: 'volumes'
            })
        },

        components: {
            ColorFeature
        },

        methods: {
            getMeshMaterialFromVolume: function (volume) {
                return modelManager.getMeshMaterials(volume.modelId);
            }
        }
    }
</script>
